import Dosa from "../images/dosa.jpg";
import Chola from "../images/chhola.jpg";
import Idli from "../images/idli.jpg";
import MasalaDosa from "../images/masala.jpg";
import Paneer from "../images/paneer.jpg";
import Indian from "../images/indian.jpg";
import Noodles from "../images/noodles.jpg";
import Pizza from "../images/pizza.jpg";
import Momos from "../images/momos.jpg";
import Dhokla from "../images/dhokla.jpg";
import Samose from "../images/samose.jpg";
import Manchurian from "../images/manchurian.jpg";
export const MenuList = [
  {
    name: "Dosa",
    description:
      "Dosa is a popular South Indian dish that has gained widespread popularity not only in India but also internationally. It is a type of thin, crispy pancake or crepe made from a fermented batter primarily consisting of rice and black gram (urad dal). Dosa is typically served with various accompaniments, such as coconut chutney, sambar (a lentil-based vegetable stew), and tomato-based sauces.",
    image: Dosa,
    price: "₹200",
  },
  {
    name: "Chole",
    description:
      "Chole, also known as Chana Masala, is a popular North Indian dish made from chickpeas (garbanzo beans) cooked in a flavorful and aromatic spiced gravy. It is a staple in Indian cuisine and is often enjoyed with various types of bread such as roti, naan, or bhature, or with rice. Chole is not only delicious but also rich in protein and fiber, making it a nutritious choice.",
    image: Chola,
    price: "₹250",
  },
  {
    name: "Idli Sambhar",
    description:
      "Idli Sambar is a classic and beloved South Indian dish that consists of idlis (steamed rice cakes) served with sambar (a flavorful lentil and vegetable stew) and various chutneys. This dish is a staple breakfast or snack in South India and has gained popularity throughout India and beyond due to its delicious and nutritious qualities.",
    image: Idli,
    price: "₹120",
  },
  {
    name: "Masala Dosa",
    description:
      "Masala Dosa is a popular South Indian dish that consists of a crispy and thin rice and lentil crepe (dosa) filled with a spiced potato mixture (masala). It is a well-loved dish that's not only popular in South India but also enjoyed across the country and even internationally. Masala dosa is typically served with coconut chutney and sambar (a lentil-based vegetable stew).",
    image: MasalaDosa,
    price: "₹100",
  },
  {
    name: "Shahi Paneer",
    description:
      "Shahi Paneer is a rich and flavorful North Indian dish made with paneer (Indian cottage cheese) cooked in a creamy tomato-based gravy.Shahi Paneer exemplifies the opulent and diverse flavors of North Indian cuisine. Its creamy texture, aromatic spices, and tender paneer make it a favorite among vegetarians and non-vegetarians alike.",
    image: Paneer,
    price: "₹270",
  },
  {
    name: "Indian Food",
    description:
      "Indian cuisine is renowned worldwide for its rich and diverse flavors, aromatic spices, and a wide variety of dishes that vary across regions. With a history spanning thousands of years, Indian food has evolved through cultural influences, trade, and traditions, resulting in a complex and vibrant culinary landscape. ",
    image: Indian,
    price: "₹300",
  },
  {
    name: "Noodles",
    description:
      "Noodles are a versatile and popular type of staple food made from unleavened dough that is stretched, rolled, and cut into thin strips. They are enjoyed in various cultures around the world and come in a wide range of shapes, sizes, and flavors. Noodles can be prepared in countless ways, from simple and quick stir-fries to elaborate and flavorful dishes.",
    image: Noodles,
    price: "₹79",
  },
  {
    name: "Pizza",
    description:
      "Pizza is a beloved and iconic Italian dish that has become popular worldwide. It consists of a round, flat base of dough topped with a variety of ingredients, including tomato sauce, cheese, and various toppings, which are then baked in an oven. Pizza comes in numerous styles and variations, allowing for a wide range of flavors and combinations.",
    image: Pizza,
    price:"₹199",
  },
  {
    name: "Momos",
    description:
      "Momos are a type of dumpling that originated in Tibet but have gained widespread popularity across various countries, especially in South Asia. These delicious bite-sized parcels are made by wrapping a thin layer of dough around a filling, which can be vegetarian or non-vegetarian. Momos are typically steamed or occasionally fried, resulting in a soft and flavorful outer layer with a savory and often juicy interior.",
    image: Momos,
    price: "₹90",
  },
  {
    name: "Dhokla",
    description:
      "Dhokla is a popular and traditional Indian dish that originates from the state of Gujarat. It is a spongy, steamed cake made primarily from fermented chickpea flour (besan) or rice flour. Dhokla is known for its light, fluffy texture and tangy flavor, making it a popular snack or breakfast item.",
    image: Dhokla,
    price: "₹90",
  },
  {
    name: "Samose",
    description:
      "Samosa, also spelled as-samosha, is a popular and savory Indian snack that consists of a crispy and flaky pastry shell filled with a spiced mixture of potatoes, peas, and sometimes other ingredients. Samosas are commonly enjoyed as a street food, appetizer, or snack throughout India and many other countries.",
    image: Samose,
    price: "₹50",
  },
  {
    name: "Manchurian",
    description:
      "Manchurian is a popular Indo-Chinese dish that consists of deep-fried vegetable or meat balls, known as-Manchurian balls, tossed in a savory, tangy, and sometimes spicy sauce. This dish is a fusion of Chinese cooking techniques and flavors adapted to suit Indian tastes, resulting in a unique and flavorful culinary creation.",
    image: Manchurian,
    price: "₹210",
  },
];